export default __webpack_public_path__ + "media/zurb/img/events/wired/dst/dst-image1-69ce2894d44070efa50d5b6eaa91ef0a.jpg";